import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=35d50aa6&scoped=true"
import script from "./indexPage.vue?vue&type=script&lang=js"
export * from "./indexPage.vue?vue&type=script&lang=js"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=35d50aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d50aa6",
  null
  
)

export default component.exports